// removed by extract-text-webpack-plugin
module.exports = {"purchaseSection":"qempo_Purchase_purchaseSection-124TlKR","loading":"qempo_Purchase_loading-3dYxkNH"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/components/Purchase.scss
// module id = 1866
// module chunks = 0